import React from 'react';
import { useSelector } from 'react-redux';
import { Divider, Grid, Typography, Box } from '@mui/material';
import ContainerBox from 'components/ContainerBox';
import * as ShopSelectors from 'selectors/ShopSelectors';
import * as UserSelectors from 'selectors/UserSelectors';
import { useTranslation } from 'services/localization';
import PosTriggerTypeSelection from '../components/PosTriggerTypeSelection';
import { PosTriggerType, ShopPlugins } from 'common/types';
import CloudPosDetails from './CloudPosDetails';

interface Props {
	cloudPosData: ShopPlugins['cloudPos'];
	onCloudPosDataChange: (data: ShopPlugins['cloudPos']) => void;
}

const CloudPos = (props: Props) => {
	const { t } = useTranslation();
	const shopReadOnlyInfo = useSelector(ShopSelectors.activeShopReadOnly);
	const shopId = useSelector(ShopSelectors.activeShopId)!;
	const locations = useSelector(ShopSelectors.activeShopAllLocations);
	const cloudPosData = shopReadOnlyInfo?.integrations?.CLOUD_POS;
	const legacyCloudPosInUse = !!cloudPosData?.legacyConnectorIntegration;
	const isAdmin = useSelector(UserSelectors.isAdmin);

	const handleTriggerTypesChange = async (triggerTypes: PosTriggerType[]) => {
		props.onCloudPosDataChange({ triggerTypes });
	};

	return (
		<ContainerBox padding="normal">
			<Grid container spacing={2}>
				<Grid item sm={12} md={6}>
					<Typography variant="h6" gutterBottom>
						{'Solteq Commerce Cloud'}
					</Typography>
					{!legacyCloudPosInUse && (
						<>
							<Typography gutterBottom variant="body2">
								{t(
									'integrations.cloudPos.info1',
									'Connect Rentle to your Solteq Commerce Cloud point of sale system',
								)}
								.
							</Typography>
							{isAdmin && (
								<Typography variant="body2">
									{t(
										'integrations.cloudPos.info2',
										'Create and share your secret key and other visible account details with Solteq Commerce Cloud to connect the integration',
									)}
									.
								</Typography>
							)}
						</>
					)}
				</Grid>
				<Grid item xs={12} md={6}>
					{isAdmin && !legacyCloudPosInUse && (
						<>
							<CloudPosDetails
								cloudPosData={cloudPosData}
								merchantId={shopId}
								storeDetails={locations.map((l) => ({ name: l.name, id: l.id }))}
							/>
							<Box my={2}>
								<Divider />
							</Box>
						</>
					)}
					<PosTriggerTypeSelection
						selectedTriggerTypes={props.cloudPosData?.triggerTypes ?? []}
						onTriggerTypesChange={handleTriggerTypesChange}
						posType="CLOUD_POS"
					/>
				</Grid>
			</Grid>
		</ContainerBox>
	);
};

export default CloudPos;
